/* Product Media Gallery JavaScript */
(function () {
  "use strict";

  function initProductGallery() {
    const galleries = document.querySelectorAll(
      ".product-gallery-new[data-gallery-container]"
    );

    galleries.forEach((gallery) => {
      const mainImageContainer = gallery.querySelector(
        "[data-main-image-container]"
      );
      const thumbnailsContainer = gallery.querySelector(
        "[data-thumbnails-container]"
      );

      // --- ADD CHECK ---
      if (!thumbnailsContainer) {
        return; // Skip this gallery
      }

      const thumbnailsScroll = gallery.querySelector(
        "[data-thumbnails-scroll]"
      );
      const progressBar = gallery.querySelector("[data-progress-bar]");
      const progressFill = gallery.querySelector("[data-progress-fill]");

      const mainImages = mainImageContainer.querySelectorAll(
        ".gallery-main-image__slide"
      );
      const thumbnails =
        thumbnailsContainer.querySelectorAll(".gallery-thumbnail");
      const secondaryThumbnails = gallery.querySelectorAll(
        ".gallery-secondary-thumbnail"
      );
      const secondaryThumbnailsScroll = gallery.querySelector(
        "[data-secondary-thumbnails-scroll]"
      );
      const scrollUpBtn = gallery.querySelector(".gallery-scroll-up");
      const scrollDownBtn = gallery.querySelector(".gallery-scroll-down");

      let currentIndex = 0;

      // Initialize gallery
      function init() {
        updateProgressBar();
        setupThumbnailNavigation();
        setupSecondaryThumbnailNavigation();
        setupScrollArrows();
        setupKeyboardNavigation();
        setupTouchNavigation();
      }

      // Update progress bar based on scroll position
      function updateProgressBar() {
        if (!progressBar || !progressFill || !thumbnailsScroll) return;

        const scrollWidth = thumbnailsScroll.scrollWidth;
        const clientWidth = thumbnailsScroll.clientWidth;
        const scrollLeft = thumbnailsScroll.scrollLeft;

        if (scrollWidth > clientWidth) {
          progressBar.style.display = "block";
          const progress = (scrollLeft / (scrollWidth - clientWidth)) * 100;
          progressFill.style.width = `${progress}%`;
        } else {
          progressBar.style.display = "none";
        }
      }

      // Setup thumbnail navigation
      function setupThumbnailNavigation() {
        thumbnails.forEach((thumbnail, index) => {
          thumbnail.addEventListener("click", (e) => {
            e.preventDefault();
            setActiveImage(index);
            scrollThumbnailIntoView(index);
          });
        });
      }

      // Setup secondary thumbnail navigation (desktop)
      function setupSecondaryThumbnailNavigation() {
        secondaryThumbnails.forEach((thumbnail, index) => {
          thumbnail.addEventListener("click", (e) => {
            e.preventDefault();
            setActiveImage(index);
          });
        });
      }

      // Setup scroll arrows for secondary thumbnails
      function setupScrollArrows() {
        if (!secondaryThumbnailsScroll || !scrollUpBtn || !scrollDownBtn)
          return;

        const scrollAmount = 220; // Height of one thumbnail + gap

        scrollUpBtn.addEventListener("click", () => {
          secondaryThumbnailsScroll.scrollBy({
            top: -scrollAmount,
            behavior: "smooth",
          });
        });

        scrollDownBtn.addEventListener("click", () => {
          secondaryThumbnailsScroll.scrollBy({
            top: scrollAmount,
            behavior: "smooth",
          });
        });

        function arrowsShouldBeVisible() {
          const { scrollHeight, clientHeight } = secondaryThumbnailsScroll;
          return scrollHeight > clientHeight;
        }

        function applyArrowVisibility() {
          const visible = arrowsShouldBeVisible();
          const displayValue = visible ? "" : "none";
          scrollUpBtn.style.display = displayValue;
          scrollDownBtn.style.display = displayValue;
        }

        // Update arrow visibility based on scroll position
        function updateScrollArrows() {
          applyArrowVisibility();
          const { scrollTop, scrollHeight, clientHeight } =
            secondaryThumbnailsScroll;

          if (scrollUpBtn.style.display !== "none") {
            scrollUpBtn.style.opacity = scrollTop > 0 ? "1" : "0.3";
            scrollUpBtn.disabled = scrollTop <= 0;
          }
          if (scrollDownBtn.style.display !== "none") {
            scrollDownBtn.style.opacity =
              scrollTop < scrollHeight - clientHeight ? "1" : "0.3";
            scrollDownBtn.disabled = scrollTop >= scrollHeight - clientHeight;
          }
        }

        // Initial update
        updateScrollArrows();

        // Update on scroll and resize
        secondaryThumbnailsScroll.addEventListener(
          "scroll",
          updateScrollArrows
        );
        window.addEventListener("resize", updateScrollArrows);
      }

      // Set active image and thumbnail
      function setActiveImage(index) {
        // Remove active class from all images, thumbnails, and secondary thumbnails
        mainImages.forEach((img) => img.classList.remove("active"));
        thumbnails.forEach((thumb) => thumb.classList.remove("active"));
        secondaryThumbnails.forEach((thumb) =>
          thumb.classList.remove("active")
        );

        // Add active class to current image, thumbnail, and secondary thumbnail
        if (mainImages[index]) {
          mainImages[index].classList.add("active");
        }
        if (thumbnails[index]) {
          thumbnails[index].classList.add("active");
        }
        if (secondaryThumbnails[index]) {
          secondaryThumbnails[index].classList.add("active");
        }

        currentIndex = index;
      }

      // Scroll thumbnail into view
      function scrollThumbnailIntoView(index) {
        if (!thumbnailsScroll || !thumbnails[index]) return;

        const thumbnail = thumbnails[index];
        const containerRect = thumbnailsScroll.getBoundingClientRect();
        const thumbnailRect = thumbnail.getBoundingClientRect();

        const scrollLeft = thumbnailsScroll.scrollLeft;
        const thumbnailLeft = thumbnail.offsetLeft;
        const thumbnailWidth = thumbnail.offsetWidth;
        const containerWidth = thumbnailsScroll.clientWidth;

        // Calculate if thumbnail is fully visible
        const isFullyVisible =
          thumbnailLeft >= scrollLeft &&
          thumbnailLeft + thumbnailWidth <= scrollLeft + containerWidth;

        if (!isFullyVisible) {
          // Center the thumbnail in the container
          const targetScrollLeft =
            thumbnailLeft - containerWidth / 2 + thumbnailWidth / 2;
          thumbnailsScroll.scrollTo({
            left: Math.max(0, targetScrollLeft),
            behavior: "smooth",
          });
        }
      }

      // Keyboard navigation
      function setupKeyboardNavigation() {
        gallery.addEventListener("keydown", (e) => {
          if (e.key === "ArrowLeft") {
            e.preventDefault();
            const newIndex =
              currentIndex > 0 ? currentIndex - 1 : mainImages.length - 1;
            setActiveImage(newIndex);
          } else if (e.key === "ArrowRight") {
            e.preventDefault();
            const newIndex =
              currentIndex < mainImages.length - 1 ? currentIndex + 1 : 0;
            setActiveImage(newIndex);
          }
        });
      }

      // Touch navigation
      function setupTouchNavigation() {
        let startX = 0;
        let startY = 0;
        let endX = 0;
        let endY = 0;

        mainImageContainer.addEventListener("touchstart", (e) => {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
        });

        mainImageContainer.addEventListener("touchend", (e) => {
          endX = e.changedTouches[0].clientX;
          endY = e.changedTouches[0].clientY;

          const deltaX = endX - startX;
          const deltaY = endY - startY;

          // Only trigger if horizontal swipe is greater than vertical
          if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
            if (deltaX > 0) {
              // Swipe right - previous image
              const newIndex =
                currentIndex > 0 ? currentIndex - 1 : mainImages.length - 1;
              setActiveImage(newIndex);
            } else {
              // Swipe left - next image
              const newIndex =
                currentIndex < mainImages.length - 1 ? currentIndex + 1 : 0;
              setActiveImage(newIndex);
            }
          }
        });
      }

      // Update progress bar on scroll
      if (thumbnailsScroll) {
        thumbnailsScroll.addEventListener("scroll", updateProgressBar);
        window.addEventListener("resize", updateProgressBar);
      }

      // Initialize the gallery
      init();
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initProductGallery);
  } else {
    initProductGallery();
  }
})();
